import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "admin-main-content" }
const _hoisted_2 = { class: "admin-content-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, " 상품 프로모션 목록 ", -1)
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body table-responsive p-0" }
const _hoisted_7 = { class: "table table-hover text-nowrap" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "프로모션 이미지"),
    /*#__PURE__*/_createVNode("th", null, "프로모션 제목"),
    /*#__PURE__*/_createVNode("th", null, "순서"),
    /*#__PURE__*/_createVNode("th", null, "등록일시"),
    /*#__PURE__*/_createVNode("th", null, "바로가기")
  ])
], -1)
const _hoisted_9 = { class: "pagination-wrapper" }
const _hoisted_10 = { class: "pagination justify-content-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "page-link",
    href: "#",
    tabindex: "-1"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "이전")
  ])
], -1)
const _hoisted_12 = {
  class: "page-link",
  href: "#"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "page-link",
    href: "#"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "다음")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goResgiter && _ctx.goResgiter(...args)))
        }, "등록")
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("table", _hoisted_7, [
            _hoisted_8,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productList, (promotion) => {
                return (_openBlock(), _createBlock("tr", {
                  key: promotion.data_id
                }, [
                  _createVNode("td", null, [
                    _createVNode("img", {
                      src: promotion.thumbnail_url + '?w=200',
                      alt: "",
                      width: "111",
                      height: "73"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("td", null, _toDisplayString(promotion.title), 1),
                  _createVNode("td", null, _toDisplayString(promotion.idx), 1),
                  _createVNode("td", null, _toDisplayString(promotion.create_at), 1),
                  _createVNode("td", null, [
                    _createVNode("button", {
                      class: "btn btn-primary",
                      onClick: ($event: any) => (_ctx.viewDetail(promotion.data_id))
                    }, " 상세보기 ", 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createVNode("nav", _hoisted_9, [
            _createVNode("ul", _hoisted_10, [
              _hoisted_11,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.totalPage, (index) => {
                return (_openBlock(), _createBlock("li", {
                  class: "page-item",
                  key: index,
                  onClick: ($event: any) => (_ctx.loadPage(index - 1))
                }, [
                  _createVNode("a", _hoisted_12, _toDisplayString(index), 1)
                ], 8, ["onClick"]))
              }), 128)),
              _hoisted_13
            ])
          ])
        ])
      ])
    ])
  ]))
}